import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Landing, { Gate, useGate } from './Landing';
import Teams from './Teams';
import { Privacy, Terms } from './Legal';
import reportWebVitals from './reportWebVitals';

// Path-switched surfaces, no router dependency: the public root is the gated
// beta landing page; the operations dashboard lives at /dashboard behind the
// same gate; /teams hosts the Teams meeting app; /privacy and /terms are the
// public policies the app stores require.
function Site() {
  const { open, tryCode } = useGate();
  const path = window.location.pathname;

  if (path.startsWith('/dashboard')) {
    return open ? <App /> : <Gate onOpen={tryCode} />;
  }
  if (path.startsWith('/teams')) return <Teams />;
  if (path.startsWith('/privacy')) return <Privacy />;
  if (path.startsWith('/terms')) return <Terms />;
  return <Landing />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Site />
  </React.StrictMode>
);

reportWebVitals();
